var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFooter)?_c('div',{staticClass:"footer-text"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }